import React from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { useVerification, VerificationStage } from '../contexts/VerificationContext';

interface VerificationBannerProps extends RouteComponentProps {}

const VerificationBannerComponent: React.FC<VerificationBannerProps> = ({ location }) => {
    const { verificationStage, isLoading } = useVerification();

    const hidePaths = ['/customer/verification', '/email-verification', '/sms-verification'];

    const showBanner = !hidePaths.includes(location.pathname) &&
                       !isLoading && // Don't show while initially loading
                       verificationStage !== VerificationStage.LOADING &&
                       verificationStage !== VerificationStage.ALL_COMPLETE &&
                       verificationStage !== VerificationStage.ERROR; // Don't show on error or if complete

    if (!showBanner) {
        return null;
    }

    const message = verificationStage === VerificationStage.CHECKS_PENDING
        ? "Verification submitted, final checks pending..."
        : "Your account needs to be verified...";

    return (
        <div className="verification-banner">
            <p className="mb-0">
                {message}{' '}
                <Link className="underline" to="/customer/verification">
                    {verificationStage === VerificationStage.WAITING_USER_VERIFICATION ? 'Verify' : 'View Status'}
                </Link>
            </p>
        </div>
    );
};

export default withRouter(VerificationBannerComponent);